<div>
    <div class="page-wrapper">
        <app-wallet-header (rightSidebarEvent)="rightSidebar($event)"></app-wallet-header>
        <div class="page-body-wrapper">
            <div class="page-sidebar" [class.open]="navServices.collapseSidebar">
                <app-sidebar></app-sidebar>
            </div>
            <div class="page-body">
                <app-wallet-breadcrumb></app-wallet-breadcrumb>
                <main [@animateRoute]="getRouterOutletState(o)">
                    <router-outlet #o="outlet"></router-outlet>
                </main>
            </div>
            <footer class="footer">
                <app-wallet-footer></app-wallet-footer>
            </footer>
        </div>
    </div>
</div>